module.exports = __webpack_public_path__ + "img/QRaigc.12082715.png";